import {useMemo} from "react";
import CampaignForm from "./CampaignForm";
import {useFindCampaignByIdQuery} from "../../core/reducers/campaign";
import {useFindTemplateByIdQuery} from "../../core/reducers/templates";
import {getEnvName} from "../Utils/CommonUtils";
import {MODE} from "./campaignMode";
import Loading from "../Loading";
import {useSearchParams} from "react-router-dom";
import {useSelector} from "react-redux";
import {campaignFromApi} from "./campaignFormModel";

/**
 * Загружает кампанию или шаблон и открывает конструктор в режиме UPDATE / CLONE / POLY.
 * POLY — шаблон из существующей кампании (/creator/templates/:campaignId?campaign).
 */
export default function UpdateCampaignForm(props) {
    const {campaignId, mode, template} = props;
    const [searchParams] = useSearchParams();
    const sourceMode = useSelector((state) => state.data.SourceMode);
    const ev = getEnvName('env', sourceMode, searchParams);

    // шаблон из кампании и обычные кампании читаются из campaign API, шаблоны — из template API
    const fromCampaign = !template || mode === MODE.POLY;
    const campaignQuery = useFindCampaignByIdQuery({ev, id: campaignId}, {skip: campaignId === 'null' || !fromCampaign});
    const templateQuery = useFindTemplateByIdQuery({ev, id: campaignId}, {skip: campaignId === 'null' || fromCampaign});
    const query = fromCampaign ? campaignQuery : templateQuery;
    const source = query.data;

    const campaign = useMemo(
        () => source ? campaignFromApi(source, {mode, template}) : null,
        [source, mode, template]
    );

    return (
        <Loading isLoading={query.isLoading} isError={query.isError} error={query.error}>
            {campaign && <CampaignForm
                template={template}
                mode={mode}
                title={campaignId}
                campaign={campaign}
            />}
        </Loading>
    );
}
